<template>
    <v-list-item two-line>
        <v-list-item-content>
            <v-list-item-subtitle>{{ reply.field.title }}</v-list-item-subtitle>
            <v-row dense>
                <v-col
                        v-if="isDocument"
                        cols="12">
                    <span
                            v-for="(photo, photoIndex) in reply.field_photo"
                            :key="photoIndex"
                            class="caption">
                        <v-icon x-small>
                            mdi-download
                        </v-icon><a
                                :href="photo.url"
                                download
                                target="_blank"
                                class="caption ma-1">
                            {{ photo.filename || 'unknown file name' }}
                        </a>
                    </span>
                </v-col>
                <v-col
                        v-else
                        cols="12">
                    <img
                            v-for="(photo, photoKey) in reply.field_photo"
                            :key="photoKey"
                            class="mr-4 elevation-3"
                            width="200px"
                            :src="photo.url">
                </v-col>
            </v-row>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
    import {TYPE_FILE_DOCUMENT} from "@/models/field.model";

    export default {
        name: "FieldPhotoReply",
        props: {
            reply: {type: Object, default: () => {}}
        },
        computed: {
            isDocument() {
                return this.reply.field.photo.type === TYPE_FILE_DOCUMENT
            }
        }
    }
</script>

<style scoped>

</style>